import React, { useState, useEffect, useContext, useCallback } from "react";
import { TranslatorContext } from "../../../../context/Translator";
import axios from "axios";
import { ButtonComponent } from "../../../../components/elements";
import { Modal, Row, Col, Form, Table, Pagination } from "react-bootstrap";
import PageLayout from "../../../../layouts/PageLayout";
import { Link } from "react-router-dom";
import '../../App/modalstyle.css';

export default function EmployeesIndex() {
    const { t } = useContext(TranslatorContext);
    const API_BASE = `${process.env.REACT_APP_API_URL}/admin/emplyees`;
    const authHeaders = { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } };

    const [employees, setEmployees] = useState([]);
    const [loading, setLoading] = useState(true);
    const [actionLoading, setActionLoading] = useState(false);

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    // Modals
    const [alertModal, setAlertModal] = useState(false);
    const [formModal, setFormModal] = useState(false);

    const [currentId, setCurrentId] = useState(null);
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        password: "",
        password_confirmation: ""
    });
    const [errors, setErrors] = useState({});

    const fetchEmployees = useCallback(async (page = 1) => {
        setLoading(true);
        try {
            const res = await axios.get(`${API_BASE}?page=${page}`, authHeaders);
            setEmployees(res.data?.data || []);
            if (res.data?.meta) {
                setCurrentPage(res.data.meta.current_page);
                setTotalPages(res.data.meta.last_page);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, [API_BASE]);

    useEffect(() => {
        fetchEmployees(currentPage);
    }, [fetchEmployees, currentPage]);

    const openModal = (item = null) => {
        setErrors({});
        if (item) {
            setCurrentId(item.id);
            setFormData({
                name: item.name || "",
                email: item.email || "",
                phone: item.phone || "",
                password: "",
                password_confirmation: ""
            });
        } else {
            setCurrentId(null);
            setFormData({
                name: "",
                email: "",
                phone: "",
                password: "",
                password_confirmation: ""
            });
        }
        setFormModal(true);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setActionLoading(true);
        setErrors({});

        try {
            let res;
            if (currentId) {
                res = await axios.put(`${API_BASE}/${currentId}`, formData, authHeaders);
            } else {
                res = await axios.post(API_BASE, formData, authHeaders);
            }

            if (res.data?.success || res.status === 200 || res.status === 201) {
                fetchEmployees(currentPage);
                setFormModal(false);
            }
        } catch (err) {
            if (err.response?.status === 422) {
                setErrors(err.response.data.errors || {});
            } else {
                console.error("Submit Error:", err);
            }
        } finally {
            setActionLoading(false);
        }
    };

    const handleDelete = async () => {
        if (!currentId) return;
        setActionLoading(true);
        try {
            await axios.delete(`${API_BASE}/${currentId}`, authHeaders);
            fetchEmployees(currentPage);
            setAlertModal(false);
        } catch (err) {
            console.error("Delete Error:", err);
        } finally {
            setActionLoading(false);
            setCurrentId(null);
        }
    };

    if (loading && employees.length === 0) {
        return <PageLayout><p>{t("loading")}...</p></PageLayout>;
    }

    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className="mc-breadcrumb">
                            <h3 className="mc-breadcrumb-title">{t("employees")}</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item">
                                    <Link to="#" className="mc-breadcrumb-link">{t("home")}</Link>
                                </li>
                                <li className="mc-breadcrumb-item">{t("employees")}</li>
                            </ul>
                        </div>
                    </div>
                </Col>

                <Col xl={12}>
                    <div className="mc-card">
                        <div className="mc-card-header d-flex justify-content-between align-items-center p-3">
                            <h5 className="mc-card-title mb-0">{t("employee list")}</h5>
                            <ButtonComponent
                                type="button"
                                className="btn btn-primary d-flex align-items-center"
                                onClick={() => openModal()}
                            >
                                <i className="material-icons me-1">add</i>
                                {t("add employee")}
                            </ButtonComponent>
                        </div>

                        <Row>
                            <Col xl={12}>
                                <div className="mc-card">
                                    <div className="table-responsive-wrapper">
                                        <Table responsive className="table mb-0">
                                            <thead>
                                                <tr>
                                                    <th><div className="mc-table-check"><p>#</p></div></th>
                                                    <th>{t("name")}</th>
                                                    <th>{t("email")}</th>
                                                    <th>{t("phone")}</th>
                                                    <th>{t("role")}</th>
                                                    <th>{t("actions")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {employees.map((item, index) => (
                                                    <tr key={item.id || index}>
                                                        <td><div className="mc-table-check"><p>{index + 1}</p></div></td>
                                                        <td>{item.name}</td>
                                                        <td>{item.email}</td>
                                                        <td>{item.phone}</td>
                                                        <td><span className="badge bg-info">{item.role}</span></td>
                                                        <td>
                                                            <div className="mc-table-action">
                                                                <ButtonComponent
                                                                    type="button"
                                                                    className="material-icons edit me-2"
                                                                    onClick={() => openModal(item)}
                                                                    title="Edit"
                                                                >
                                                                    edit
                                                                </ButtonComponent>
                                                                <ButtonComponent
                                                                    type="button"
                                                                    className="material-icons delete"
                                                                    onClick={() => {
                                                                        setCurrentId(item.id);
                                                                        setAlertModal(true);
                                                                    }}
                                                                    title="Delete"
                                                                >
                                                                    delete
                                                                </ButtonComponent>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>

                                    {/* Pagination Controls */}
                                    {totalPages > 1 && (
                                        <div className="d-flex justify-content-end p-3">
                                            <Pagination>
                                                <Pagination.Prev
                                                    disabled={currentPage === 1}
                                                    onClick={() => setCurrentPage((prev) => prev - 1)}
                                                />
                                                {[...Array(totalPages)].map((_, i) => (
                                                    <Pagination.Item
                                                        key={i + 1}
                                                        active={i + 1 === currentPage}
                                                        onClick={() => setCurrentPage(i + 1)}
                                                    >
                                                        {i + 1}
                                                    </Pagination.Item>
                                                ))}
                                                <Pagination.Next
                                                    disabled={currentPage === totalPages}
                                                    onClick={() => setCurrentPage((prev) => prev + 1)}
                                                />
                                            </Pagination>
                                        </div>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>

            {/* Form Modal (Create / Edit) */}
            <Modal show={formModal} onHide={() => setFormModal(false)} centered dialogClassName="custom-modal-dialog" contentClassName="custom-modal-content">
                <Modal.Header closeButton className="p-3">
                    <Modal.Title>{currentId ? t("edit employee") : t("add employee")}</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleSubmit}>
                    <Modal.Body>
                        <Form.Group className="mb-3">
                            <Form.Label>{t("name")} <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                isInvalid={!!errors.name}
                                placeholder="Enter full name"
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.name?.[0]}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>{t("email")} <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                isInvalid={!!errors.email}
                                placeholder="Enter email address"
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.email?.[0]}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>{t("phone")} <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                type="text"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                isInvalid={!!errors.phone}
                                placeholder="Enter phone number"
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.phone?.[0]}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>{t("password")} {!currentId && <span className="text-danger">*</span>}</Form.Label>
                            <Form.Control
                                type="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                isInvalid={!!errors.password}
                                placeholder={currentId ? "Leave blank to keep current password" : "Enter password"}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.password?.[0]}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>{t("confirm password")} {!currentId && <span className="text-danger">*</span>}</Form.Label>
                            <Form.Control
                                type="password"
                                name="password_confirmation"
                                value={formData.password_confirmation}
                                onChange={handleChange}
                                placeholder="Confirm password"
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer className="p-2">
                        <ButtonComponent type="button" className="btn btn-secondary" onClick={() => setFormModal(false)}>
                            {t("cancel")}
                        </ButtonComponent>
                        <ButtonComponent type="submit" className="btn btn-primary" disabled={actionLoading}>
                            {actionLoading && <span className="spinner-border spinner-border-sm me-2"></span>}
                            {currentId ? t("update") : t("save")}
                        </ButtonComponent>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/* Delete Confirmation Modal */}
            <Modal show={alertModal} onHide={() => setAlertModal(false)} centered>
                <div className="mc-alert-modal p-4 text-center">
                    <i className="material-icons" style={{ fontSize: "50px", color: "red" }}>new_releases</i>
                    <h3 className="mt-3">{t("Are you sure?")}</h3>
                    <p>{t("Want to delete this employee?")}</p>
                    <div className="d-flex justify-content-center gap-2 mt-3">
                        <ButtonComponent type="button" className="btn btn-secondary" onClick={() => setAlertModal(false)}>
                            {t("close")}
                        </ButtonComponent>
                        <ButtonComponent type="button" className="btn btn-danger" onClick={handleDelete} disabled={actionLoading}>
                            {actionLoading ? <span className="spinner-border spinner-border-sm me-2"></span> : t("delete")}
                        </ButtonComponent>
                    </div>
                </div>
            </Modal>
        </PageLayout>
    );
}